import React from 'react';

/** Estimate ⇒ Work Order conversion icon (More Actions menu). */
const CreateWorkOrderSvg = ({ color = 'black' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M9.16667 18.3317H2.50003L2.5 2.91663H5.83337M12.5 2.91663H15.8333V11.6666" stroke={color} strokeWidth="1.5" strokeLinecap="square" />
        <path
            d="M11.2497 1.66663H7.08301C6.39265 1.66663 5.83301 2.22627 5.83301 2.91663C5.83301 3.60698 6.39265 4.16663 7.08301 4.16663H11.2497C11.94 4.16663 12.4997 3.60698 12.4997 2.91663C12.4997 2.22627 11.94 1.66663 11.2497 1.66663Z"
            fill={color}
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="square"
        />
        <path d="M5.83301 12.5H8.69017M5.83301 9.16663H12.4997" stroke={color} strokeWidth="1.5" strokeLinecap="square" />
        <path d="M17.5003 14.1666L13.3337 18.3333L11.667 16.6666" stroke={color} strokeWidth="1.5" strokeLinecap="square" />
    </svg>
);

export default CreateWorkOrderSvg;
